import { useEffect, useState } from "react";
import { changePassword } from "../helpers/tableauUserHelpers";
import { useNavigate, useLocation } from "react-router-dom";
import parse from 'html-react-parser';

import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import { validTimeStamp } from "../helpers/tableauUserHelpers";

import PageLogoHeader from "./pageLogoHeader";
import "./passwordrecovery.css";


function PasswordRecoveryChange(props){
    console.log('We made it here');
    console.log(props);
    let navigate = useNavigate();
    const location = useLocation();
    const [webuserID, setWebuserID] = useState('');
    const [disabled, setDisabled] = useState('disabled');
    const [disableSubmit, setDisableSubmit] = useState('disabled');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [newPasswordMessage, setNewPasswordMessage] = useState('');

    const fetchValidTimeStamp = async(webuserid) => {
        return await validTimeStamp(webuserid);
    };

    const fetchSetNewPassword = async(webuserid, password) => {
        return await changePassword(webuserID, password);
    }

    const handleClearInputs = event => {
        setNewPassword('');
        setConfirmPassword('');
        setNewPasswordMessage('');
    };

    const handleSubmit = async event => {
        const password = document.getElementById('confirm-new-password').value;
        console.log('set new password');
        try{
            let msg = await fetchSetNewPassword(webuserID, password); 
            console.log(msg);
            ccbhmessagebox({
                message: msg,
                title: "Password Changed",
                modal:true,
                closebutton: false,
                buttons: {
                    'Ok': function() {
                        removeMsg();
                        navigate("/");
                    }
                }
            });
        }catch(err){
            console.log('Error changing password ', err);
        }
    };
    
    const errors = {
        uppercase: { regex: /[A-Z]/, description: 'At least one uppercase letter' },
        lowercase: { regex: /[a-z]/, description: 'At least one lowercase letter' },
        digit: { regex: /[0-9]/, description: 'At least one digit' },
        special: { regex: /[^A-Za-z0-9]/, description: 'At least one special symbol' },
        length: { test: e => e.length > 8, description: 'Must be 9 characters or more' },
     };
     
    const checkPasswordComplexity = (password) =>{
        return Object.entries(errors).flatMap(([name, { test, regex, description }]) => {
            const isValid = test ? test(password) : regex.test(password);
            return isValid ? [] : { description, name };
          });
    }

    const enableConfirm = event => {
        const pwdCmplxErr = checkPasswordComplexity(event.currentTarget.value);
        if(pwdCmplxErr.length === 0){
            setNewPassword(event.currentTarget.value);
            setDisabled('');
            setNewPasswordMessage('');
        }else{
            setDisabled('disabled');
            setDisableSubmit('disabled');
            setNewPassword('');
            let errMsg = '';
            pwdCmplxErr.forEach((e) => {
                errMsg += e.description + '<br />';
            });

            setNewPasswordMessage('New password is not well formed:<br />' + errMsg);
        }
    }

    const handleConfirmPasswordChange = event => {
        if(event.currentTarget.value !== newPassword){
            setNewPasswordMessage('New Password and Confirm Password must match');
            setDisableSubmit('disabled');
        }else{
            setNewPasswordMessage('');
            setDisableSubmit('');
        }
    }

    useEffect(() => {
        let webuserid = location.pathname.split('/')[1];
        setWebuserID(webuserid);
        console.log(webuserID);

        fetchValidTimeStamp(webuserid).then((isValid) =>{
            console.log(isValid?.valid);
            if(isValid?.valid !== 'true'){
                navigate("/");
            }
        })

        }, 
    []);
    
    return(
        <>
            <PageLogoHeader />
            <input type="hidden" id="username" name="username" defaultValue={webuserID} />
            <div className="new-password-section">
                <p className="instructions" id="change-password">Enter A New Password</p>

                <input type="password" id="new-password" name="new-password" defaultValue="" onChange={enableConfirm}/>
                <br />
                <label htmlFor="new-password">New Password</label>
                <br/><br/>
                <input type="password" data-1p-ignore data-lpignore="true" id="confirm-new-password" name="confirm-new-password" defaultValue="" disabled={disabled} onChange={handleConfirmPasswordChange} />
                <br />
                <label htmlFor="new-password">Confirm Password</label>
            </div>
            <div className="button_section" >
                    <input type="reset" id="reset-new-password" value="Clear" onClick={handleClearInputs} />
                    <input type="submit" id="submit-new-password" name="submit-new-password" value="Submit" disabled={disableSubmit} onClick={handleSubmit} />
                </div>
            <div id="new-password-message-section">
                <label className="warning2" id="pwd-changed">{parse(newPasswordMessage)}</label>
            </div>
        </>
    );
};

export default PasswordRecoveryChange;